import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL;

class MenuService{

    async getPaginaByPermalink(token, lingua, permalink){

        return axios({
            method: 'get',
            url: API_URL + 'pagine/GetPaginaByPermalink', 
            params:{               
                lingua: lingua,
                permalink: permalink
            },           
            headers:{
                    Authorization: 'Bearer '+ token,
                    'Content-Type': 'application/json'
            }
        }).then(data =>  {            
            if(data.status && data.status == 401){
                return false;
            }
            return data.data
        });
       
    }

    async getWidgetsByIdPagina(token, idPagina){

        return axios({
            method: 'get',
            url: API_URL + 'pagine/GetWidgetByIdPagina', 
            params:{               
                idPagina: idPagina               
            },           
            headers:{
                    Authorization: 'Bearer '+ token,
                    'Content-Type': 'application/json'
            }
        }).then(data =>  {            
            if(data.status && data.status == 401){
                return false;
            }
            return data.data
        });
       
    }
}

export default new MenuService();